module.exports = __webpack_public_path__ + "img/icon-sustainable.97cde75.svg";